import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

const DEFAULT_FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const DEFAULT_FILE_EXTENSION = '.xlsx';

const exportToExcel = async ({ fileName = '엑셀파일', sheets, items }) => {
  if (items.length > 0) {
    const workbook = new ExcelJS.Workbook();

    await sheets.forEach(({ sheetName, fieldLabels, fieldValues }) => {
      const currentSheet = workbook.addWorksheet(sheetName);
      currentSheet.addRow(fieldLabels);

      items.forEach((item) => {
        const rowData = fieldValues(item);
        currentSheet.addRow(rowData);
      });
    });

    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const excelData = new Blob([buffer], { type: DEFAULT_FILE_TYPE });
        FileSaver.saveAs(excelData, fileName + DEFAULT_FILE_EXTENSION);
      })
      .catch((error) => {
        console.error('Error saving file:', error);
      });
  } else {
    alert('출력할 데이터가 존재하지 않습니다.');
  }
};

export default exportToExcel;
